// extracted by mini-css-extract-plugin
module.exports = {"empty-state-image-sizes":"styles-module__empty-state-image-sizes___3GXFX"};